export default "__VITE_ASSET__STlhiy7j__"